import AJAXForm from '../lib/AJAXForm.js';

let getInTouch = {
	init: function(){
		const _self = this;

		$('input, select, textarea').on('invalid', e => {
			const element = e.target;

			element.form.classList.add('form--invalid');

			if(element.parentNode.classList.contains('form__group')) {
				element.parentNode.classList.add('invalid');
			}
		}).on('change', element => {
			if(element.target.parentNode.classList.contains('form__group')) {
				element.target.parentNode.classList.remove('invalid');
			}
		});

		document.querySelectorAll('#get-in-touch').forEach(element => {
			element.form = new AJAXForm(element);

			element.form.fail(error => {
				let alerts = element.querySelector('#alerts');

				if(alerts !== null){
					element.removeChild(alerts);
				}

				alerts = _self.createAlerts((error.messages.errors.length) ? error.messages.errors : ['An error occurred please try again']);
				element.insertBefore(alerts, element.firstChild);
			});

			element.form.done(() => {
				let wrapper = element.closest('#get-in-touch-form');

				if(wrapper !== null){
					$(wrapper).slideUp();
					$(wrapper).siblings('#thankyou').slideDown();
				}
			});
		});

		document.querySelectorAll('#let-us-help__form').forEach(element => {
			element.form = new AJAXForm(element);

			element.form.fail(error => {
				let alerts = element.querySelector('#alerts');

				if(alerts !== null){
					element.removeChild(alerts);
				}

				alerts = _self.createAlerts((error.messages.errors.length) ? error.messages.errors : ['An error occurred please try again']);
				element.insertBefore(alerts, element.firstChild);
			});

			element.form.done(message => {
				// let evt = new MouseEvent('click', {
				// 	bubbles: true,
				// 	cancelable: true,
				// 	view: window
				// });
				element.reset();
				// element.previousElementSibling.previousElementSibling.dispatchEvent(evt);
				$(element).slideUp(300, function(){
					$(element).next().delay(100).fadeIn(400);
				});
			});
		});
	},
	createAlerts : function(messages){
		let html = document.createElement("div");
		html.id = 'alerts';

		messages.forEach(function(message) {
			let alert = document.createElement("div");
			alert.classList.add('alert', 'alert--error');
			alert.innerHTML = message;

			html.insertBefore(alert, html.firstChild);
		});

		return html;
	}
};

let search = {
	init: function () {
		if(document.getElementById('search') !== null){
			$('#search-who').on('change', this.populateSubCategory); //chosen-js event isn't captured by vanilla js event handlers...
			document.getElementById('search').addEventListener('submit', this.redirect);
			this.populateSubCategory(document.getElementById('search-who'))
		}

	},
	populateSubCategory: e => {
		let el = (typeof e.target !== 'undefined') ? e.target : e
		  , childJSON = JSON.parse(el.options[el.selectedIndex].getAttribute('data-children'))
		  , forSelect = document.getElementById('search-for')
		  , blankOption = document.createElement('option');
		
		// console.log(childJSON);

		blankOption.value = "";
		blankOption.text = "Select a value";
		blankOption.disabled = true;
		blankOption.selected = true;

		forSelect.innerHTML = '';
		forSelect.appendChild(blankOption);

		childJSON.forEach(ele => {
			let option = document.createElement("option");
			option.value = ele.post_name;
			option.text = ele.post_title;

			if (typeof e.target === 'undefined' && ele.post_name === 'mortgage-advice'){
				option.selected = true;
			}

			forSelect.appendChild(option);
		});

		$(forSelect).trigger('chosen:updated');

		return true;
	},
	redirect: e => {
		let forSelect = document.getElementById('search-for')
		  , whoSelect = document.getElementById('search-who')
		  , path = null;

		e.preventDefault();

		e.target.querySelectorAll('.search-form__group').forEach(ele => {
			ele.classList.remove('invalid');
		});

		if(whoSelect.value.length && forSelect.value.length){
			path = [whoSelect.value, forSelect.value].join('/');
			window.location = window.location.origin + '/' + path;
		} else {
			[whoSelect, forSelect].forEach(ele => {
				if(!ele.value.length){
					ele.closest('.search-form__group').classList.add('invalid');
				}
			});
		}

		return true;
	}
};

export { getInTouch as default, search };
